import Cookie from 'js-cookie';
import { PersistStore } from './ActivitySessionManager';
import { toJSDate } from './utils/Time';

const COOKIE_STORE_KEY = 'm_asi';

export const activitySessionManagerPersist: PersistStore = {
  load: () => Cookie.get(COOKIE_STORE_KEY),
  save: (sessionId: string, expires: number) =>
    Cookie.set(COOKIE_STORE_KEY, sessionId, { expires: toJSDate(expires) }),
  clear: () => Cookie.remove(COOKIE_STORE_KEY),
};
